<template>
  <RevCard class="p-32">
    <h2 class="heading-2">
      {{ i18n(translations.title) }}
    </h2>

    <div class="body-1 mt-8">
      {{ i18n(translations.subtitle) }}
    </div>

    <div class="grid-standard mt-32 !gap-24">
      <template v-for="insight in insights">
        <div
          v-if="insight.label"
          :key="insight.name"
          class="border-static-default-low rounded-md flex flex-col items-start justify-between border border-solid p-24 md:col-span-2 lg:col-span-4"
        >
          <h3 class="heading-3 mt-8">
            {{ insight.label }}
          </h3>

          <div class="body-1 mt-8">
            {{ insight.description }}
          </div>

          <RevButton
            class="mt-16"
            size="small"
            :to="{
              name: ROUTE_NAMES.INSIGHTS.INDEX,
              query: { tableau: insight.name },
            }"
            :tracking="{ zone: 'insights_hub_cards', name: insight.name }"
            variant="secondary"
          >
            {{
              i18n(translations.goToReportButtonLabel, { name: insight.label })
            }}
          </RevButton>
        </div>
      </template>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'

import type { Insight } from '~/api/insights/types'
import { ROUTE_NAMES } from '~/constants/routes'

import translations from './Home.translations'

const i18n = useI18n()
defineProps<{ insights: Insight[] }>()
</script>
